{
  "title": {
    "create": "Crie um terreno",
    "edit": "Editar terreno"
  },
  "name": "Nome",
  "bounds": "Pula",
  "tiles": "Telhas",
  "remove_tiles": "Remover ladrilhos",
  "Pending": "Pendente",
  "Active": "Ativo",
  "Deleted": "Excluído",
  "terrain_options": "Clique para abrir as opções de terreno",
  "edit": "Editar terreno",
  "delete": "Excluir terreno",
  "uploading_tiles": "Carregando blocos"
}